const initialState = {
    anchor: 'left',
    visita: [],
    totalItems: 0,
    open: false,
    id: '',
    id_fazenda: '0',
    data: '',
    tipo_relatorio: '',
    arquivo: '',
    obs: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
    fazenda: null
};

export function visita(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_VISITA':
            return {
                ...state,
                visita: action.visita,
                totalItems: action.totalItems
            };
        case 'VISITA_DETAIL':
            return {
                ...state,
                id: action.id,
                id_fazenda: action.id_fazenda,
                data: action.data,
                tipo_relatorio: action.tipo_relatorio,
                arquivo: action.arquivo,
                obs: action.obs,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                fazenda: action.fazenda
            };
        case "VISITA_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        case 'VISITA_CLEAR':
            return initialState;
        default:
            return state
    }
}
